import React from 'react';
import moment from 'moment';
import { Text, Icon, IconName } from '@upsales/components';
import Bem from '@upsales/components/Utils/bemClass';
import { Colors } from '@upsales/components/Utils/colors';
import T from 'Components/Helpers/translate';

export const outcomeTypes = {
	COMPLETED: 'completed',
	NOTCOMPLETED: 'notCompleted',
	PLANNED: 'planned'
} as const;

export const getOutcomeStatus = (outcome: (typeof outcomeTypes)[keyof typeof outcomeTypes]) => ({
	outcomeCompleted: outcome === outcomeTypes.COMPLETED,
	outcomeNotCompleted: outcome === outcomeTypes.NOTCOMPLETED
});

/**
 * A meeting cannot have happened before it starts, so `completed` is only offered from its
 * start time onwards. Read the date off the form rather than the stored row, so moving a
 * meeting forward closes the option again.
 *
 * Only `completed`: `notCompleted` on a future date is a state the product produces on
 * purpose - "it didn't happen, here is the new date" is what the outcome card's reschedule
 * saves (`saveOutcomeComment` writes the outcome and the new date together).
 */
export const hasMeetingStarted = (date: Date | string | null | undefined) => !!date && moment().isAfter(date);

export const getButtonMainText = (textTag: string, iconName: IconName, iconColor: Colors, bold: boolean) => (
	<>
		<Icon name={iconName} color={iconColor} />
		<Text size="sm" color="black" bold={bold}>
			{T(textTag)}
		</Text>
	</>
);

export const getMainClass = () => new Bem('AppointmentModal--Outcomes');
